/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import BackButton from '../../../../../components/shared/Buttons/BackButton';
import OrgAppList from '../views/organization/application/OrgAppList';
import OrgAppCreationBtn from '../views/organization/application/OrgAppCreationBtn';
import Loader from '../../../../../components/ui-elements/loader';
import { useParams } from 'react-router-dom';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { getAllAppsByOrgID } from '../../../../../store/reducers/organization/orgApp/orgAppAction';

const ManageOrganizationApplicationsPage = () => {
    const [loading, setLoading] = useState(false);
    const { orgid } = useParams();
    const dispatch = useDispatch()
    const fetchOrgApps = useCallback(async () => {
        try {
            setLoading(true);
            await dispatch(getAllAppsByOrgID({ 'organizationID': orgid })).unwrap()
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }, [orgid, dispatch])
    useEffect(() => {
        fetchOrgApps()
    }, [fetchOrgApps]);
    return (
        <>
            <Box m={6}>
                <Grid container spacing={4} >
                    <Grid item xs={12} sm={12} md={12}>
                        <BackButton pageTitle={'Manage Organization Applications'} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} />

                    <Grid item xs={12} sm={6} md={6} >
                        <OrgAppCreationBtn />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                        {!loading ? <OrgAppList /> : (<Loader />)}
                    </Grid>

                </Grid>
            </Box>

        </>
    )

}


export default ManageOrganizationApplicationsPage; 